import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { getCategory } from '@/logic/main/utils';
import { getLocale } from '@/utils';

export const getJackpotsComponentsContent = async (
  context: LogicContext,
  event: { type: string; jackpotCode?: string }
) => {
  const {
    shuffleGames,
    multiJackpots,
    currentJackpotsV2,
    controllersData,
    user,
    strikeGoldData,
  } = context;
  const locale = getLocale(config);
  const currency = user?.currency || config.default_currency;
  const { loggedIn } = user;
  const { drawnGame } = shuffleGames;
  if (!controllersData?.categories || !event?.jackpotCode) {
    return {
      updates: [],
    };
  }

  const updates = controllersData
    .categories!.components.filter(
      ([o, entry]) =>
        entry.properties?.type === 'Jackpot Hero' ||
        entry.properties?.type === 'Jackpot Banner'
    )
    .map(([id, entry]) => {
      if (event?.jackpotCode === entry.properties.jackpot_tile.provider) {
        return {
          type: 'setLayoutProperty',
          data: {
            path: `components.${id}.properties`,
            value: {
              category: getCategory({
                category: {
                  ...entry.properties,
                },
                multiJackpots,
                currentJackpotsV2,
                shuffleGame: drawnGame,
                currency,
                locale,
                strikeGoldData,
              }),
              currency,
              loggedIn,
              locale,
              visible: !context.isGameModalForMobileOpened,
            },
          },
        };
      }
      return null;
    })
    .filter(Boolean);

  return {
    updates,
  };
};
